<template>
    
    <div>
      <validation-provider
        v-slot="validationContext"
        name="Bio Başlık"
        rules="required"
      >
        <b-form-group
          label="Bio Başlık"
          label-for="campaign_name"
        >
          <b-form-input
            id="campaign_name"
            v-model="localValue.campaign_name"
            :state="getValidationState(validationContext)"
            @input="emitUpdate"
            trim
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
      <b-form-group label="Kısa Link">
        <b-input-group
        :prepend="typeData.model === 'bio' && typeData.short_link_domain ? typeData.short_link_domain : ($store.state.user.customerInfo.short_link_domain ? $store.state.user.customerInfo.short_link_domain : 'https://fenomany.com/short/' + $store.state.user.customerInfo.id + '/')">
          <b-form-input
            v-model="localValue.short_code"
            :disabled="!shortCodeEditMode"
            ref="shortCodeInput"
            @blur="onShortCodeBlur"
            :maxlength="14"
            @input="onInputBioShortCode"
          />
          <b-input-group-append v-if="!shortCodeEditMode">
            <b-button size="sm" variant="primary" @click="editShortCode">
              Düzenle
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
  </template>
  
  <script>
  
  import store from '@/store'
  
  import {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormInvalidFeedback, 
    BFormRadio,
    BFormRadioGroup
  } from 'bootstrap-vue'
  import { ValidationProvider } from 'vee-validate'
  
  export default {
    components: {
      BFormGroup,
      BFormInput,
      BInputGroup,
      BInputGroupAppend,
      BButton,
      BFormInvalidFeedback,
      ValidationProvider,
      BFormRadio,
      BFormRadioGroup
    },
    props: {
      linkData: { type: Object, required: true },
      editingLink: { type: Object, default: null },
      startDate: { type: Object, required: true },
      endDate: { type: Object, required: true },
      platformOptions : {type : Array },
      typeData: { type: Object, required: true }
    },
    data() {
      return {
        localValue: { ...this.linkData },
        shortCodeEditMode: false,       
      }
    },
    watch: {
        linkData: {
            handler(newVal) {
              this.localValue = { ...newVal };
            },
            deep: true, // `linkData` bir nesne olduğu için `deep: true` gereklidir
        },
        'localValue.platform_id': function (newPlatform) {
            if (!newPlatform) return;

            // type bilgisini bileşenin mevcut state'inden alıyoruz (ör. this.typeData.id veya this.localValue.type)
            const currentTypeId = this.typeData?.id || this.localValue?.type;

            if (!currentTypeId) {
                console.warn('Type bilgisi bulunamadığı için link sorgusu atılamadı.');
                return;
            }

            this.$http.get('/link', {
                  params: {
                    filter:{
                      type: currentTypeId,
                      platform_id: newPlatform,
                    },
                    perPage: 1,  // limit yerine bu parametre okunuyor
                    page: 1,
                    sortDesc: true,
                }
            }).then((response) => {
                const resData = response.data;

                // API yapınıza göre tek nesne veya dizi kontrolü
                let linkRecord = null;
                if (resData.success) {
                    linkRecord = resData.data?.Links?.[0] ?? (Array.isArray(resData.data) ? resData.data[0] : resData.data);
                }
                console.log('Link sorgu sonucu:', linkRecord);
                if (linkRecord && (linkRecord.url_code || linkRecord.short_code)) {
                    const code = linkRecord.url_code || linkRecord.short_code;
                    this.localValue.short_code = code;
                    if (this.linkData) {
                        this.linkData.short_code = code;
                    }
                } else {
                    // Uygun kayıt bulunamadıysa fallback (örneğin platformOptions'tan veya boş)
                    const fallbackPlatform = this.platformOptions?.find(p => p.value === newPlatform);
                    const fallbackCode = fallbackPlatform?.short_code || '';

                    this.localValue.short_code = fallbackCode;
                    if (this.linkData) {
                        this.linkData.short_code = fallbackCode;
                    }
                }
            }).catch((error) => {
                console.error('Link getirme hatası:', error);
            });
        }
        // 'localValue.platform_id': function (newPlatform) {
        //     if (!newPlatform) return; // Eğer platform seçilmemişse işlemi durdur
        //     const selectedPlatform = this.platformOptions.find(p => p.value === newPlatform);
        //     if (selectedPlatform) {
        //       this.localValue.short_code = selectedPlatform.short_code || 'test'; // Varsayılan olarak 'test' atanır
        //       this.linkData.short_code = selectedPlatform.short_code || 'test'; // Varsayılan olarak 'test' atanır
        //     } else {
        //     console.warn(`Seçilen platform bulunamadı: ${newPlatform}`);
        //     }
        // },
    },
    methods: {
      emitUpdate() {
        this.$emit('update', { ...this.localValue })
      },
        onInputBioShortCode(value) {
            // Sadece izinli karakterlere zorla ve kısa kodu güncelle
            this.localValue.short_code = value.replace(/[^A-Za-z0-9_]/g, '').slice(0, 14);
        },  
      editShortCode() {
        this.shortCodeEditMode = true
        this.$nextTick(() => {
          this.$refs.shortCodeInput.focus()
        })
      },
      onShortCodeBlur() {
        this.shortCodeEditMode = false
        this.emitUpdate()
        this.updateShortCode()
      },
      updateShortCode() {
            this.$http.put('platforms/' + this.localValue.platform_id, {
                id: this.localValue.platform_id,
                short_code: this.localValue.short_code,
            }).then((response) => {
                this.$toast('Kısa kod başarıyla güncellendi.', {
                title: 'Başarılı',
                variant: 'success',
                solid: true,
                });
            }).catch((error) => {
                console.error('Hata:', error.response || error); // Hata detaylarını kontrol edin
                this.$toast('Kısa kod güncellenirken bir hata oluştu.', {
                title: 'Hata',
                variant: 'danger',
                solid: true,
                });
            });
        },
        
      getValidationState(context) {
        if (context) return context.validated ? !context.invalid : null
        return null
      },
    },
    

  }
  </script>